import { render, staticRenderFns } from "./scoreList.vue?vue&type=template&id=216cc98e&scoped=true&"
import script from "./scoreList.vue?vue&type=script&lang=js&"
export * from "./scoreList.vue?vue&type=script&lang=js&"
import style0 from "./scoreList.vue?vue&type=style&index=0&id=216cc98e&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216cc98e",
  null
  
)

export default component.exports